export default {
    state: {
        currentGeoLocationPosition: {
            lat: null,
            lng: null,
        },
    },
    mutations: {
        currentGeoLocationPosition: (state, value) => {
            state.currentGeoLocationPosition = value;
        },
    },
    getters: {
        currentGeoLocationPosition: (state) => state.currentGeoLocationPosition,
    },
    actions: {
        async fetchCurrentPosition(context) {
            return new Promise((resolve, reject) => {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            if (position && position.coords) {
                                context.commit('currentGeoLocationPosition', {
                                    lat: position.coords.latitude,
                                    lng: position.coords.longitude,
                                });
                                resolve();
                            }
                        },
                        (err) => {
                            reject(err);
                        }
                    );
                } else {
                    resolve();
                }
            });
        },
    },
};
